// ─────────────────────────────────────────────────────────────────────────────
// supabaseClient.js — Phase 2
// Initialises the Supabase JS client. Imported once, used everywhere.
//
// Credentials come from .env.local (never committed to git):
//   VITE_SUPABASE_URL      — Supabase project URL
//   VITE_SUPABASE_ANON_KEY — anon public key (safe for frontend, RLS enforced)
//
// The service role key is NEVER used here — only in Edge Functions (server-side).
// ─────────────────────────────────────────────────────────────────────────────

import { createClient } from '@supabase/supabase-js';

// CRA uses process.env.REACT_APP_* (not import.meta.env.VITE_*)
const SUPABASE_URL  = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON || SUPABASE_URL.includes('placeholder')) {
  // eslint-disable-next-line no-console
  console.warn(
    '[PSP/CRE] Supabase credentials not configured. ' +
    'Exercise mode (multi-user) will be unavailable. ' +
    'Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to .env.local to enable.'
  );
}

export const supabase = createClient(
  SUPABASE_URL  || 'https://placeholder.supabase.co',
  SUPABASE_ANON || 'placeholder-anon-key',
  {
    auth: {
      // persistSession: true — trainer session survives browser close ("remember me")
      // Stored under psp_cre_trainer_session key in localStorage
      persistSession: true,
      storageKey: 'psp_cre_trainer_session',
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);
